import React, { useState, useEffect } from 'react';
import EditorPreviewMyWork from './ArticleStates/EditorPreviewMyWork';
import ChannelEditorApprovalMyWork from './ArticleStates/ChannelEditorApprovalMyWork';
import EditorScreeningMyWork from './ArticleStates/EditorScreeningMyWork';

const MyWorksMain = ({channel, currentUser, myWorksPath}) => {

  const [data, setData] = useState([]);
  
  const [editorPreviewCount, setEditorPreviewCount] = useState(0);
  const [channelEditorApprovalCount, setChannelEditorApprovalCount] = useState(0);
  const [editorScreeningCount, setEditorScreeningCount] = useState(0);
  const [articleCount, setArticleCount] = useState(0);
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    setArticleCount(editorPreviewCount + channelEditorApprovalCount + editorScreeningCount)
  }, [editorPreviewCount, channelEditorApprovalCount, editorScreeningCount])

  const fetchData = () => {
    setSpinning(true)
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: myWorksPath,
      success: function(data) {
        setData(data)
        setEditorPreviewCount(data.initial_data.editor_preview.total)
        setChannelEditorApprovalCount(data.initial_data.channel_editor_approval.total)
        setEditorScreeningCount(data.initial_data.editor_screening.total)
        setSpinning(false)
        $(document).foundation('reflow');
      }
    });
  }

  const renderSpinner = () => {
    if (spinning) {
      return <img className="spinner" src='https://public.cureus.com/ajax-loader.gif'/>
    }
  }

  const renderChevronContainer = (expanded, setExpanded, className='') => {
    return (
      <div className="chevron-arrow-container">
        <img
          src="https://public.cureus.com/channel-icons/chevron-thin-down.png"
          onClick={() => setExpanded(!expanded)}
          onMouseOver={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-hovered-down.png")}
          onMouseOut={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-thin-down.png")}
          onMouseDown={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-clicked-down.png")}
          onMouseUp={e => (e.currentTarget.src = "https://public.cureus.com/channel-icons/chevron-hovered-down.png")}
          className={`chevron-toggle ${className} ${expanded ? "rotate" : ""}`}
        />
      </div>
    )
  }

  if (articleCount === 0) {
    return (
    <div className="my-works-channel-container">
      <div className="default-my-works-container">
        {renderSpinner()}
        {!spinning && (<h3>You have no current work.</h3>)}
      </div>
    </div>
      )
  } else {
    return (
      <div className='my-works-channel-container'>
        <h5 className="articles-header">Your action needed
          <span> ({articleCount})</span>
        </h5>
        <div className="articles-container">
          {editorScreeningCount > 0 && (
            <EditorScreeningMyWork renderChevronContainer={renderChevronContainer} articlesPath={myWorksPath} initialData={data.initial_data.editor_screening} isParent={true} myWork={true}/>
          )}
          {editorPreviewCount > 0 && (
            <EditorPreviewMyWork renderChevronContainer={renderChevronContainer} articlesPath={myWorksPath} initialData={data.initial_data.editor_preview}/>
          )}
          {channelEditorApprovalCount > 0 && (
            <ChannelEditorApprovalMyWork renderChevronContainer={renderChevronContainer} articlesPath={myWorksPath} initialData={data.initial_data.channel_editor_approval} isParent={false} myWork={true}/>
          )}
        </div>
      </div>
    )
  }
}

export default MyWorksMain;